import { Navigate, Outlet } from "react-router-dom";

export default function PrivateRoute() {
  const user = sessionStorage.getItem("user");

  // ❌ Not logged in → redirect to login
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // ✅ Logged in → allow access
  return <Outlet />;
}
